import { TealiumResponse } from '@/types/writeup';
import { generateElement } from '@/common/helpers';

export function createTealiumScript(tealiumData: TealiumResponse) {
	const existingTealiumScript = document.querySelector(`script[src="https:${tealiumData.jsAsyncScriptUrl}"]`);

	if (existingTealiumScript) {
		const head = document.getElementsByTagName('head')[0];

		head.removeChild(existingTealiumScript);
	}

	const scriptBodyData = `(function(a,b,c,d){
		a='https:${tealiumData.jsAsyncScriptUrl}';
		b=document;c='script';d=b.createElement(c);d.src=a;d.
			type='text/java'+c;d.async=true;d.onload=_tealiumLoaded;a=b.getElementsByTagName(c)
			[0];a.parentNode.insertBefore(d,a)})();`;

	const scriptHeadData = `
		var _dl = ${JSON.stringify(tealiumData.dataLayer)};

		var _trackAnalytics = function() {
		};

		var _tealiumLoaded = function() {
		};

		function updateTealiumDataLayer(data, sendEvent = true) {
			if (data) {
				_dl = data;
				if (sendEvent) {
					sendTealiumAnalyticsData(data);
				}
			}
		}

		function sendTealiumAnalyticsData(data) {
			if (!_dl || typeof _trackAnalytics !== 'function' || !data) {
				return;
			}

			try {
				_trackAnalytics(data);
			} catch (error) {
				console.error(error);
			}
		}`;

	generateElement(scriptHeadData, 'dr-tealium-head-script', 'script', 'head');
	generateElement(scriptBodyData, 'dr-tealium-body-script', 'script', 'body');
}
